import { render, staticRenderFns } from "./StartingNext.vue?vue&type=template&id=b8f51736&scoped=true"
import script from "./StartingNext.vue?vue&type=script&lang=js"
export * from "./StartingNext.vue?vue&type=script&lang=js"
import style0 from "./StartingNext.vue?vue&type=style&index=0&id=b8f51736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f51736",
  null
  
)

export default component.exports